export function ifElse(condition: any, trueValue: any, falseValue: any): any {
  return condition ? trueValue : falseValue
}

export function someTrue(...params: boolean[]): boolean {
  return params.some(condition => condition)
}

export function everyTrue(...params: boolean[]): boolean {
  return params.every(condition => condition)
}

export function defaultTo<T>(...params: [...Array<T | null | undefined>, T]): T {
  for (const param of params) {
    if (param !== null && param !== undefined) {
      return param
    }
  }

  return params[params.length - 1] as T
}

export function defaultWhenEmpty<T>(value: any, defaultValue: T): T {
  return value !== null && value !== undefined && value !== '' ? value : defaultValue
}
